import React, { useReducer, useState, useEffect } from 'react';
import {
  DataSolicitationContainer,
  DataSolicitationWrapper,
  DataSolicitationHeader,
  DataSolicitationHeaderTitle,
  DataSolicitationHeaderArea,
  DataSolicitationContent,
} from './styles';
import { dataSolicitationSteps, maritalStatus } from '../../helpers/enum';
import { DataSolicitationContext } from '../../store/';
import { useHistory, useLocation } from 'react-router-dom';
import { H4, P } from '../../components/Typography/styles';
import dataSolicitationReducer from '../../store/DataSolicitation';
import colors from '../../assets/styles/colors';
import FormSteps from '../../components/FormSteps';
import NewFormSteps from '../../components/FormStepsSimulator';
import Copyright from '../../components/Copyright';
import Loader from '../../components/Loader';
import INITIAL_STATE_DATA_SOLICITATION from '../../store/DataSolicitation/state';
import BasicDataPage from './BasicData';
import AditionalDataPage from './AditionalData';
import ComplementDataPage from './ComplementData';
import WorkDataPage from './WorkData';
import CreditDataPage from './CreditData';
import ResultPage from './Result';
import { default as DataSolicitationTypes } from '../../store/DataSolicitation/types';
import { getCreditById, getLastCreditByClient } from '../../services/credit';
import { getClientDataFull } from '../../services/clients'
import { getSolicitationById } from '../../services/solicitations';
import { getExtracts } from '../../services/extract';
import { getSolicitaionDataByCreditId } from '../../services/dataSolicitation';
import { getEducational } from '../../services/educational';
import { getStates } from '../../services/states';
import { isPricing } from '../../services/tasas';
import OldBasicDataPage from './OldBasicData';
import OldWorkDataPage from './OldWorkData';
import OldCreditDataPage from './OldCreditData';
import OldResultPage from './OldResult';
import { getPiloto } from '../../services/desk';

const DataSolicitationPage = () => {
  const location = useLocation();
  const history = useHistory();
  const [dataSolicitation, setDataSolicitation] = useReducer(dataSolicitationReducer, INITIAL_STATE_DATA_SOLICITATION);
  const [activeStep, setActiveStep] = useState(dataSolicitationSteps.BASIC_DATA);
  const [lastStep, setLastStep] = useState(dataSolicitationSteps.DEFAULT);
  const [isLoading, setIsLoading] = useState(true);
  const [newPricing, setNewPricing] = useState(false);
  
  async function initializeStateComponent() {
    try {
      const creditResponse = await getCreditById(location.idCredit);
      const solicitationResponse = await getSolicitationById(location.idCredit);
      const extractResponse = await getExtracts();
      const extract = await extractResponse.data.find(item => item.idLegado === solicitationResponse.data.cliente.estrato);
      const educationalLevelReponse = await getEducational();
      const educationalLevelByUser = educationalLevelReponse.data.find(item => item.idLegado === solicitationResponse.data.credito.nivelEducativo);
      const estadoCivil = await maritalStatus.find(item => item.id === solicitationResponse.data.credito.estadoCivil);
      const dataSolicitationResponse = await getSolicitaionDataByCreditId(location.idCredit);
      const states = await getStates();
      //const departamentoByUser = states.data.find(dataSolicitationResponse.data.simulacion.departamento !== null || dataSolicitationResponse.data.simulacion.departamento !== undefined ? item => item.id === dataSolicitationResponse.data.simulacion.departamento: null);
      let departamentoByUSimulation = null;
      if(dataSolicitationResponse.data.simulacion.departamento !== null &&
        dataSolicitationResponse.data.simulacion.departamento !== undefined) {
        const departamentoByUser = states.data.find(item =>item.id === dataSolicitationResponse.data.simulacion.departamento);
        departamentoByUSimulation=departamentoByUser?.nombre;
      }
      const lastCreditResponse = await getLastCreditByClient(location.client.id);
      const clientDataResponse = await getClientDataFull(location.client.identificationType, location.client.identification);

      const response = await isPricing(dataSolicitationResponse.data.credito.idOficina);
      const isPiloto = await getPiloto(dataSolicitationResponse.data.credito.idOficina);
      if(isPiloto.data.isNuevoSimulador){
        setNewPricing(true);
      }else{
        setNewPricing(false);
      }
      await setDataSolicitation({
        type: DataSolicitationTypes.SET_PRICING,
        pricing: response.data
      });

      await setDataSolicitation({
        type: DataSolicitationTypes.SET_BASIC_DATA,
        basicData: {
          ...dataSolicitation.basicData,
          idOficina: solicitationResponse.data.simulacion.idOficina,
          nombres: solicitationResponse.data.cliente.nombres,
          fechaNacimiento: solicitationResponse.data.cliente.fechaNacimiento,
          edadCliente: solicitationResponse.data.cliente.edadCliente,
          tipoIdentificacion: solicitationResponse.data.cliente.tipoIdentificacion,
          identificacion:solicitationResponse.data.cliente.identificacion,
          fechaExpedicionDocumento: solicitationResponse.data.cliente.fechaExpedicionDocumento,
          ciudadExpedicionIdentificacion: solicitationResponse.data.cliente.ciudadExpedicionIdentificacion,
          idCiudadExpedicionIdentificacion: solicitationResponse.data.cliente.idCiudadExpedicionIdentificacion,
          nivelEducativo: educationalLevelByUser,
          celular: solicitationResponse.data.cliente.celular,
          email: solicitationResponse.data.cliente.email,
          paisNacimiento:solicitationResponse.data.cliente.paisNacimiento,
          lugarNacimiento:solicitationResponse.data.cliente.lugarNacimiento,
          nacionalidad:solicitationResponse.data.cliente.nacionalidad,
          profesion:solicitationResponse.data.credito.profesion,
          estadoCivil: null,
          genero: dataSolicitationResponse.data.simulacion.genero,
          totalActivos: dataSolicitationResponse.data.simulacion.totalActivos,
          estrato: dataSolicitationResponse.data.simulacion.estrato,
          tipoContrato: dataSolicitationResponse.data.simulacion.tipoContrato,
          departamento: departamentoByUSimulation,
          educacion: dataSolicitationResponse.data.simulacion.nivelEducativo,
          idAsesor: dataSolicitationResponse.data.cliente.idAsesorAutorizado,
          actividadCliente: dataSolicitationResponse.data.credito.actividad,
          grupoEtnico: solicitationResponse.data.cliente.grupoEtnico,
          idDepartamentoCorrespondencia: solicitationResponse.data.cliente?.idDepartamentoCorrespondencia,
          idCiudadCorrespondencia: solicitationResponse.data.cliente?.idCiudadCorrespondencia,
          valorDestino: solicitationResponse.data.simulacion.bonoSocial ? solicitationResponse.data.simulacion.bonoSocial.valorDestino : 0,
          idCiudadResidencia:solicitationResponse.data.cliente?.idCiudadResidencia,
          idDepartamentoResidencia: solicitationResponse.data.cliente?.idDepartamentoResidencia
        }
      });
      
      await setDataSolicitation({
        type: DataSolicitationTypes.SET_CREDIT,
        credit: creditResponse.data
      });

      await setDataSolicitation({
        type: DataSolicitationTypes.SET_SOLICITATION,
        solicitation: solicitationResponse.data
      });

      await setDataSolicitation({
        type: DataSolicitationTypes.SET_ADITIONAL_DATA,
        aditionalData: {
          ...dataSolicitation.aditionalData,
          estrato: extract,
          tipoVivienda: solicitationResponse.data.credito.tipoVivienda
        }
      });

      await setDataSolicitation({
        type: DataSolicitationTypes.SET_WORK_DATA,
        workData: {
          ...dataSolicitation.workData,
          data: dataSolicitationResponse.data
        }
      })
      
      await setDataSolicitation({
        type: DataSolicitationTypes.SET_LAST_CREDIT,
        lastCredit: lastCreditResponse.data
      })

      await setDataSolicitation({
        type: DataSolicitationTypes.SET_CLIENT,
        client: clientDataResponse.data
      })

      if(location.step) {
        setLastStep(location.step - 1);
        setActiveStep(location.step);
      }

      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if(!location.idCredit) {
      return history.push('/admin/dashboard');
    }

    initializeStateComponent();
  }, [])

  return (
    <DataSolicitationContainer id="data-solicitation-page">
      <DataSolicitationWrapper>
        <DataSolicitationHeader>
          <DataSolicitationHeaderTitle>Clientes</DataSolicitationHeaderTitle>
          <DataSolicitationHeaderArea>
            <H4 color={colors.textPrimary}>Datos solicitud</H4>
            <P bold color={colors.textPrimary}>
              {dataSolicitation.solicitation?.cliente.nombres} {dataSolicitation.solicitation?.cliente.tipoIdentificacion.toUpperCase()}. {dataSolicitation.solicitation?.cliente.identificacion}
            </P>
          </DataSolicitationHeaderArea>
        </DataSolicitationHeader>
        {isLoading ? <Loader /> : (
          <DataSolicitationContent id="data-solicitation-steps" style={newPricing ? { display: 'grid',marginTop: '40px' } : { display: 'grid',gridTemplateColumns: '260px 1fr',marginTop: '40px' }}>
          {newPricing &&
            <NewFormSteps lastStep={lastStep} steps={[
              {number: dataSolicitationSteps.BASIC_DATA, label: 'Datos complementarios'},
              //{number: dataSolicitationSteps.ADITIONAL_DATA, label: 'Datos Adicionales'},
              //{number: dataSolicitationSteps.COMPLEMENT_DATA, label: 'Datos complementarios'},
              {number: dataSolicitationSteps.WORK_DATA, label: 'Datos laborales o Pensionales'},
              {number: dataSolicitationSteps.CREDIT_DATA, label: 'Datos para el crédito'},
              {number: dataSolicitationSteps.RESULT, label: 'Pre-aprobado'}
            ]} />
          }
          {!newPricing &&
            <FormSteps lastStep={lastStep} steps={[
              {number: dataSolicitationSteps.BASIC_DATA, label: 'Datos complementarios'},
              //{number: dataSolicitationSteps.ADITIONAL_DATA, label: 'Datos Adicionales'},
              //{number: dataSolicitationSteps.COMPLEMENT_DATA, label: 'Datos complementarios'},
              {number: dataSolicitationSteps.WORK_DATA, label: 'Datos laborales o Pensionales'},
              {number: dataSolicitationSteps.CREDIT_DATA, label: 'Datos para el crédito'},
              {number: dataSolicitationSteps.RESULT, label: 'Pre-aprobado'}
            ]} />
          }
            

              
            <DataSolicitationContext.Provider value={{ dataSolicitation, setDataSolicitation }}>
              {activeStep === dataSolicitationSteps.BASIC_DATA && newPricing && (
                <BasicDataPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}
              {activeStep === dataSolicitationSteps.BASIC_DATA && !newPricing && (
                <OldBasicDataPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}

              {/*{activeStep === dataSolicitationSteps.ADITIONAL_DATA && (
                <AditionalDataPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}

              {activeStep === dataSolicitationSteps.COMPLEMENT_DATA && (
                <ComplementDataPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}*/}

              {activeStep === dataSolicitationSteps.WORK_DATA && newPricing && (
                <WorkDataPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}
              {activeStep === dataSolicitationSteps.WORK_DATA && !newPricing && (
                <OldWorkDataPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}

              {activeStep === dataSolicitationSteps.CREDIT_DATA && newPricing && (
                <CreditDataPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}
              {activeStep === dataSolicitationSteps.CREDIT_DATA && !newPricing && (
                <OldCreditDataPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}

              {activeStep === dataSolicitationSteps.RESULT && newPricing && (
                <ResultPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}
              {activeStep === dataSolicitationSteps.RESULT && !newPricing && (
                <OldResultPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}
            </DataSolicitationContext.Provider>
          </DataSolicitationContent>
        )}
      </DataSolicitationWrapper>
      <Copyright />
    </DataSolicitationContainer>
  )
}

export default DataSolicitationPage;